<template>
    <div>
        <div class="dg-backdrop" @click="closeDialog()"></div>
        <div class="dg-container dialog-container">
            <div class="dg-content-cont dg-content-cont--floating">
                <div class="dg-main-content">
                    <div class="dg-view-wrapper">
                        <div class="dg-content-body">
                            <div class="dg-title">
                                <h4>Problematic Subscription Info</h4>
                                <div class="subscription-id">
                                    <a :href="'https://dashboard.stripe.com/subscriptions/' + eowp.subscriptionId" target="_blank">
                                        Open in Dashboard
                                    </a>
                                </div>
                            </div>
                            
                            <div class="card-group card-group-custom card-group-corporate" id="accordion">
                                <!-- Accordion #1: Stripe Subscription record -->
                                <div class="card card-corporate">
                                    <div class="card-heading" role="tab">
                                        <div :class="'card-title' + (eowp.recordAccordion.error ? ' error' : '')">
                                            <a :href="eowp.recordAccordion.error ? '#' : '#collapse-1'" role="button" data-parent="#accordion" data-toggle="collapse" aria-controls="collapse-1">
                                                {{ eowp.recordAccordion.title }}
                                                <div class="card-arrow"></div>
                                                <span v-if="eowp.recordAccordion.loading" class="page-loading-indicator">
                                                    <img src="/images/eowp/animation/loading-spinner.jpg" />
                                                </span>
                                            </a>
                                        </div>
                                    </div>

                                    <div :class="'collapse' + (eowp.recordAccordion.error || eowp.recordAccordion.loading ? '' : ' show')" id="collapse-1" role="tabpanel">
                                        <div class="card-body"> 
                                            <div class="tabs-custom tabs-horizontal tabs-line tabs-line-small tabs-line-secondary">
                                                <ul class="nav nav-tabs">
                                                    <li class="nav-item"><a class="nav-link active" href="#tabs-2-1" data-toggle="tab">Summary</a></li>
                                                    <li class="nav-item"><a class="nav-link" href="#tabs-2-2" data-toggle="tab">checkpoint_outcome</a></li>
                                                    <li class="nav-item"><a class="nav-link" href="#tabs-2-3" data-toggle="tab">JSON</a></li>
                                                </ul>
                                                <div class="tab-content">
                                                    <!-- Subscription Record Summary -->
                                                    <div class="tab-pane fade show active" id="tabs-2-1">
                                                        <div class="information row">
                                                            <div class="col">
                                                                <div class="info-row"><span class="label">id: </span><a :href="'https://dashboard.stripe.com/subscriptions/' + eowp.subscriptionId" target="_blank">{{ eowp.subscriptionId }}</a></div>
                                                                <div class="info-row"><span class="label">status: </span>{{ eowp.subscriptionRecord.status }}</div>
                                                                <div class="info-row"><span class="label">currentPeriodStart: </span>{{ eowp.subscriptionRecord.currentPeriodStart }}</div>
                                                                <div class="info-row"><span class="label">currentPeriodEnd: </span>{{ eowp.subscriptionRecord.currentPeriodEnd }}</div>
                                                            </div>
                                                            <div class="col">
                                                                <div class="info-row"><span class="label">checkpointDate: </span>{{ eowp.subscriptionRecord.checkpointDate ? eowp.subscriptionRecord.checkpointDate : '-' }}</div>
                                                                <div class="info-row"><span class="label">createdAt: </span>{{ eowp.subscriptionRecord.createdAt ? eowp.subscriptionRecord.createdAt : '-' }}</div>
                                                                <div class="info-row"><span class="label">updatedAt: </span>{{ eowp.subscriptionRecord.updatedAt ? eowp.subscriptionRecord.updatedAt : '-' }}</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Subscription Record checkpoint_outcome -->
                                                    <div class="tab-pane fade" id="tabs-2-2">
                                                        <highlight-code lang="json">{{ eowp.subscriptionRecord.checkpointOutcome  ? eowp.subscriptionRecord.checkpointOutcome : {} }}</highlight-code>
                                                    </div>

                                                    <!-- Subscription Record JSON -->
                                                    <div class="tab-pane fade" id="tabs-2-3">
                                                        <highlight-code lang="json">{{ eowp.subscriptionRecord ? eowp.subscriptionRecord : {} }}</highlight-code>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Accordion #2: Stripe Subscription Object -->
                                <div class="card card-corporate">
                                    <div class="card-heading" role="tab">
                                        <div :class="'card-title' + (eowp.objectAccordion.error ? ' error' : '')">
                                            <a :href="eowp.objectAccordion.error ? '#' : '#collapse-2'" role="button" data-parent="#accordion" data-toggle="collapse" aria-controls="collapse-2" class="collapsed">
                                                {{ eowp.objectAccordion.title }}
                                                <div class="card-arrow"></div>
                                                <span v-if="eowp.objectAccordion.loading" class="page-loading-indicator">
                                                    <img src="/images/eowp/animation/loading-spinner.jpg" />
                                                </span>
                                            </a>
                                        </div>
                                    </div>

                                    <div class="collapse" id="collapse-2" role="tabpanel">
                                        <div class="card-body"> 
                                            <div class="tabs-custom tabs-horizontal tabs-line tabs-line-small tabs-line-secondary">
                                                <ul class="nav nav-tabs">
                                                    <li class="nav-item"><a class="nav-link active" href="#tabs-3-1" data-toggle="tab">Summary</a></li>
                                                    <li class="nav-item"><a class="nav-link" href="#tabs-3-2" data-toggle="tab">JSON</a></li>
                                                </ul>
                                                <!-- subscription -->
                                                <div class="tab-content">
                                                    <div class="tab-pane fade show active" id="tabs-3-1">
                                                        <div class="information row">
                                                            <div class="col">
                                                                <div class="info-row"><span class="label">id: </span><a :href="'https://dashboard.stripe.com/subscriptions/' + eowp.subscriptionId" target="_blank">{{ eowp.subscriptionId }}</a></div>
                                                                <div class="info-row"><span class="label">status: </span>{{ eowp.subscriptionObject.status }}</div>
                                                            </div>
                                                            <div class="col">
                                                                <div class="info-row"><span class="label">currentPeriodStart: </span>{{ eowp.subscriptionObject.current_period_start }}</div>
                                                                <div class="info-row"><span class="label">currentPeriodEnd: </span>{{ eowp.subscriptionObject.current_period_end }}</div>
                                                                <div class="info-row"><span class="label">created: </span>{{ eowp.subscriptionObject.created }}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="tab-pane fade" id="tabs-3-2">
                                                        <highlight-code lang="json">{{ eowp.subscriptionObject ? eowp.subscriptionObject : {} }}</highlight-code>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="dg-content-footer">
                            <button class="dg-btn dg-btn--cancel dg-pull-right" @click="closeDialog()">
                                <span class="dg-btn-content">
                                    閉じる
                                </span>
                            </button>
                            <div class="dg-clear"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.row + .row {
    margin-top: 5px;
}
.card {
    width: 100%;
}
.card-group.card-group-custom {
    margin-top: 20px;
}
.card-corporate .card-arrow {
    bottom: 0px;
}
.card-corporate .card-arrow, 
.card-corporate .card-arrow:hover{
    background-color: #fff;
}
.card-corporate .error .card-arrow::before, 
.card-corporate .error .card-arrow::after, 
.card-title.error a {
    color: red !important;
}
.card-corporate .error a,
.card-corporate .error .card-arrow {
    cursor: pointer;
}
.card-corporate .error .card-arrow::before,
.card-corporate .error .card-arrow::after {
	content: '\f542';
}
.card-group.card-group-corporate .card + .card {
    margin-top: 20px;
}
.page-loading-indicator {
    vertical-align: text-bottom;
}
.page-loading-indicator img{
    width: 25px;
    color: red;
    margin-left: 5px;
}
.dg-content-cont--floating {
    top: calc(50% + 30px);
}
.dialog-container {
    top: 90px!important;
}
.dg-main-content {
    max-width: 1000px;
    padding: 27px;
}
.dg-title {
    text-align: center;
}
.dg-content {
    text-align: left;
}
.dg-content-body {
    border-bottom: 1px solid #E1E6EA;
}
.dg-content-body .dg-title .subscription-id { 
    margin-bottom: 15px;
}
.card-body .info-row span.label {
    font-weight: bold;
}
.card-body .tab-pane pre {
    border: 1px solid #d8d8d8;
    max-height: 150px;
}
.dg-content-footer {
    overflow: auto;
    position: relative;
    padding: 25px 0 0;
    text-align: left !important;
}
@media screen and (max-width: 768px){
    .tabs-custom.tabs-line .tab-content {
        font-size: 13px;
    }
    .card-corporate .card-body {
        padding: 0 70px 25px 32px;
    }
}
@media screen and (min-width: 768px){
    .card-corporate .card-body {
        padding-right: 80px;
    }
}
@media screen and (max-width: 550px){
    .dg-main-content {
        padding: 20px;
    }
    .dg-content-footer {
        padding: 20px 0 0;
    }
    .tabs-custom.tabs-line .nav-tabs li.nav-item a.nav-link,
    .card-corporate .card-title a,
    .dg-title {
        font-size: 13px;
    }
    .dg-title h4{
        font-size: 16px;
    }
    .tabs-custom.tabs-line .tab-content {
        font-size: 12px;
    }
    .card-group.card-group-corporate .card + .card {
        margin-top: 5px;
    }
    .card-body .info-row span.label {
        display: block;
        line-height: 1;
        margin-top: 5px;
    }
    .dg-content-cont--floating {
        top: calc(50% + 50px);
    }
    .card-corporate .card-body {
        padding: 0 70px 25px 32px;
    }
}
</style>

<style>
    span.hljs-attr {
        color: #50d;
    }
</style>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import PaginationHelper from '../../../../js/helpers/PaginationHelper';
import VueHighlightJS from 'vue-highlight.js';
import 'vue-highlight.js/lib/allLanguages'
import 'highlight.js/styles/idea.css';
import Utils from '../../../../js/helpers/Utils';

export default {
    props: {
        subscriptionId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            dialogEnabled: true,
            eowp: {
                subscriptionId: "",
                subscriptionObject: {
                    created: '-',
                    current_period_end: '-',
                    current_period_start: '-',
                    id: '-',
                    status: '-',
                },
                subscriptionRecord: {
                    createdDate: '-',
                    currentPeriodStart: '-',
                    currentPeriodEnd: '-',
                    checkpointDate: '-',
                    subscriptionId: '-',
                    status: '-', 
                    createdAt: '-',
                    updatedAt: '-',
                    checkpointOutcome: {},
                },
                recordAccordion: {
                    title: 'Stripe Subscription Record',
                    error: false,
                    loading: true,
                },
                objectAccordion: {
                    title: 'Stripe Subscription Object',
                    error: false,
                    loading: true,
                },
                infoRequestType: {
                    SUBSCRIPTION_RECORD_REQUEST_TYPE: 3,
                    SUBSCRIPTION_OBJECT_REQUEST_TYPE: 4
                },
                minimumLoadingDelay: 500
            }
        };
    },
    async created() {
        Vue.use(VueHighlightJS);
        this.eowp.subscriptionId = this.subscriptionId;
        // shrink subscriptionId if window width < 550px
        if (window.innerWidth < 550) {
            this.eowp.subscriptionId = PaginationHelper.shrinkStr(this.eowp.subscriptionId, 8, 5, "...");
        }
        this.loadSubscriptionRecord();
        this.loadSubscriptionObject();
    }, 
    computed: {
        ...mapGetters({
            sessionDetails: 'user/session_details',
        })
    },
    methods: {
        ...mapActions({
            getSubscriptionDetail: 'ssr/getSubscriptionDetail',
            clearSubscriptionDetail: 'ssr/clearSubscriptionDetail'
        }),
        closeDialog() {
            this.clearSubscriptionDetail();
            this.$emit('close', true);
            this.dialogEnabled = false;
        },
        formatDate(timeInMilliseconds){
            let date = new Date(timeInMilliseconds);
            let formattedDate = date.getFullYear() + "-" + (date.getMonth() + 1).toString().padStart(2, '0') + "-" + (date.getDate()).toString().padStart(2, '0');
            formattedDate += " " + date.getHours().toString().padStart(2, '0') + ":" + date.getMinutes().toString().padStart(2, '0') + ":" + date.getSeconds().toString().padStart(2, '0');
            return formattedDate;
        },
        async loadSubscriptionRecord() {
            this.eowp.recordAccordion.loading = true;
            let timeStart = (new Date()).getTime();

            await this.getSubscriptionDetail({
                userId: this.sessionDetails.userId, 
                sessionId: this.sessionDetails.sessionId,
                requestType: this.eowp.infoRequestType.SUBSCRIPTION_RECORD_REQUEST_TYPE,
                subscriptionId: this.subscriptionId
            }).then(res => {
                // Session expired
                if (Utils.isEmpty(res.status_code) && res.status == 'ERROR') {
                    this.$router.push("/signout");
                    return;
                }

                let timeSpent = (new Date()).getTime() - timeStart;
                let delay = timeSpent < this.eowp.minimumLoadingDelay ? (this.eowp.minimumLoadingDelay - timeSpent) : 0;
                
                if(res.status_code != 'SUCCESS' || !res.records.object) {
                    setTimeout(() => {
                        this.eowp.recordAccordion.error = true;
                        this.eowp.recordAccordion.loading = false;
                    }, delay);
                    return;
                } else {
                    this.eowp.subscriptionRecord = JSON.parse(res.records.object);
                    setTimeout(() => {
                        this.eowp.recordAccordion.error = false;
                        this.eowp.recordAccordion.loading = false;
                    }, delay);

                    if (this.eowp.subscriptionRecord) {
                        // format date fields to standard shop date format
                        this.eowp.subscriptionRecord.currentPeriodStart = this.formatDate(this.eowp.subscriptionRecord.currentPeriodStart);
                        this.eowp.subscriptionRecord.currentPeriodEnd = this.formatDate(this.eowp.subscriptionRecord.currentPeriodEnd);
                        this.eowp.subscriptionRecord.checkpointDate = this.formatDate(this.eowp.subscriptionRecord.checkpointDate);
                        
                        if(this.eowp.subscriptionRecord.createdAt) this.eowp.subscriptionRecord.createdAt = this.formatDate(new Date(this.eowp.subscriptionRecord.createdAt));
                        if(this.eowp.subscriptionRecord.updatedAt) this.eowp.subscriptionRecord.updatedAt = this.formatDate(new Date(this.eowp.subscriptionRecord.updatedAt));

                        let checkpointOutcome = this.eowp.subscriptionRecord.checkpointOutcome;
                        this.eowp.subscriptionRecord.checkpointOutcome = !Utils.isEmpty(checkpointOutcome) ? JSON.parse(checkpointOutcome) : checkpointOutcome;
                    }
                }
            })
        },
        async loadSubscriptionObject() {
            this.eowp.objectAccordion.loading = true;
            let timeStart = (new Date()).getTime();

            await this.getSubscriptionDetail({
                userId: this.sessionDetails.userId, 
                sessionId: this.sessionDetails.sessionId,
                requestType: this.eowp.infoRequestType.SUBSCRIPTION_OBJECT_REQUEST_TYPE,
                subscriptionId: this.subscriptionId
            }).then(res => {
                let timeSpent = (new Date()).getTime() - timeStart;
                let delay = timeSpent < this.eowp.minimumLoadingDelay ? (this.eowp.minimumLoadingDelay - timeSpent) : 0;
                    
                if(res.status_code != 'SUCCESS' || !res.records.object) {
                    setTimeout(() => {
                        this.eowp.objectAccordion.error = true;
                        this.eowp.objectAccordion.loading = false;
                    }, delay);
                    return;
                } else {
                    this.eowp.subscriptionObject = JSON.parse(res.records.object);
                    setTimeout(() => {
                        this.eowp.objectAccordion.error = false;
                        this.eowp.objectAccordion.loading = false;
                    }, delay);

                    // format date fields in seconds to standard shop date format
                    this.eowp.subscriptionObject.current_period_start = this.formatDate(this.eowp.subscriptionObject.current_period_start * 1000);
                    this.eowp.subscriptionObject.current_period_end = this.formatDate(this.eowp.subscriptionObject.current_period_end * 1000);
                    this.eowp.subscriptionObject.created = this.formatDate(this.eowp.subscriptionObject.created * 1000);
                }
            })
        }
    }
}
</script>

